var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 750,
    height: 738,
    viewBox: "0 0 750 738",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M719.089 18.5C719.089 8.28273 710.806 0 700.589 0H430.285C420.068 0 411.785 8.28274 411.785 18.5V18.5C411.785 28.7173 403.503 37 393.285 37H61C27.3106 37 0 64.3107 0 98V677C0 710.689 27.3106 738 61 738H689C722.689 738 750 710.689 750 677V52.4557C750 43.9198 743.08 37 734.544 37V37C726.008 37 719.089 30.0803 719.089 21.5443V18.5Z",
    fill: "#FFD5A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftBox);
export default __webpack_public_path__ + "static/media/left-box.e33b28c9645e70e503392eabb1da213f.svg";
export { ForwardRef as ReactComponent };